import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
} from "@/shared/ui/dropdown-menu.tsx";
import { Settings2, SquarePen } from "lucide-react";
import { SetStateAction } from "react";

type EventDropdownProps = {
  setEdit: React.Dispatch<SetStateAction<boolean>>;
  event_id: number;
}

const EventDropdown = ({ setEdit }: EventDropdownProps) => {


  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="p-2 hover:bg-white rounded-full transition-all ease-in"
        >
          <Settings2 className="md:w-[20px] md:h-[20px] " />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56 font-poppins" align="end">
        <DropdownMenuLabel>Options</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuItem
            onClick={() => setEdit(prev => !prev)}
          >
            Edit
            <DropdownMenuShortcut>
              <SquarePen size={14} />
            </DropdownMenuShortcut>
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default EventDropdown;
